import { ColumnType } from '@repo/ui'

export function isAlignRight(columnType: ColumnType): boolean {
	return [
		ColumnType.number,
		ColumnType.currency,
		ColumnType.download,
		ColumnType.action,
		ColumnType.rate,
	].includes(columnType)
}

export function isAlignCenter(columnType: ColumnType): boolean {
	return [ColumnType.boolean].includes(columnType)
}
